module.exports = __webpack_public_path__ + "assets/8a0d3566b3df7cba3d5bc828387d1a99.mp4";